import { useQueryClient, useMutation } from "react-query";
import { updateUserRole } from "../../../../../actions/Utilities/ModuleManagement";
import { toast } from "../../../../../components/toastNotification";

export const useUpdateUserRole = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (user) => updateUserRole(user),
    {
      onSuccess: (res) => {
        if (res) {
          if (res.statusCode === 500 || res.statusCode === 400) {
            toast.fire("Server Error", "Cannot display data", "error");
          }
        } else {
          queryClient.invalidateQueries(["AllUser"]);
          queryClient.invalidateQueries(["GetRolesWithUsers"]);
          toast.fire(
            "Success",
            "User Role has been updated successfully.",
            "success"
          );
        }
        // queryClient.invalidateQueries(["user", userId]);
      },
    }
  );

  return mutate;
};
